export default __webpack_public_path__ + "maps-examples-add-marker-symbol-thumbnail-480-8787cbc9d24f2cc160116ebdea443356.webp";